<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {}
}
</script>
<style lang="stylus">
#app {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
input,
select,
textarea,
button {
  -webkit-appearance: none;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 100px white inset;
}
html {
  -webkit-overflow-scrolling: touch;
}
.clinet-tip {
  text-align: center;
  line-height: 160px;
}
.loading-box {
  position :fixed;
  background :rgba(0,0,0,0.5)
  border-radius :20px;
  width :160px;
  height :160px;
  left: 50%;
  top: 50%;
  color:#fff;
  transform: translate(-50%, -50%);
  z-index: 9000;
  .loading {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align :center;
    color #fff
  }
}
</style>
